/* eslint-disable curly */
import React, { Component } from "react";
import {
  View,
  Text,
  Image,
  TextInput,
  TouchableOpacity,
  ImageBackground,
  ScrollView,
  KeyboardAvoidingView,
  Platform,
  Linking,
} from "react-native";
import { EventRegister } from "react-native-event-listeners";

import Icon from "react-native-vector-icons/FontAwesome";
import IconE from "react-native-vector-icons/Entypo";
import { StackActions, NavigationActions } from "react-navigation";

import styles from "./styles";
import ButtonConfirm from "../../components/ButtonConfirm";
import { atualizar } from "../../services/aluno-service";
import { getAluno, setAluno } from "../../services/auth-service";
import Loading from "../../components/Loading";
import { validaEmail } from "../../utils/formatUtils";

class EditarEmail extends Component {
  constructor(props) {
    super();
    this.state = {
      email: "",
      confirmDisabled: true,
    };
  }

  handlerInput = (e) => {
    this.setState({
      email: e,
      confirmDisabled: !validaEmail(e),
      loading: false,
    });
  };

  handlerSubmit = async () => {
    let target = this.props.navigation.getParam("target");

    this.setState({ ...this.state, loading: true });

    let aluno = await getAluno();
    let alunoAtualizar = {
      cpf: aluno.cpf,
      email: this.state.email,
    };
    try {
      const response = await atualizar(alunoAtualizar);

      if (!response.ok) {
        this.setState({ ...this.state, loading: false });

        const erro = await response.json();

        return alert("Ops...", erro.erro);
      }

      setAluno({ ...aluno, email: this.state.email });

      this.setState({ ...this.state, loading: false });

      EventRegister.emit("reloadPerfil", "it works!!!");
      return this.props.navigation.pop();
    } catch (e) {
      console.log(e);
    }
  };

  render() {
    return (
      <>
        {this.state.loading && <Loading />}
        <KeyboardAvoidingView
          style={styles.container}
          behavior={Platform.select({
            ios: "padding",
            android: "null",
          })}
          keyboardVerticalOffset={Platform.select({ ios: 64, android: 0 })}
        >
          <ImageBackground
            source={require("../../../resources/imgs/bg.jpg")}
            style={[styles.container]}
            imageStyle={styles.imageContainer}
          >
            <ScrollView
              style={{ width: "100%" }}
              contentContainerStyle={[styles.containerForm]}
            >
              <TouchableOpacity
                style={styles.iconClose}
                onPress={() => this.props.navigation.pop(1)}
              >
                <Icon name={"close"} size={30} color="#FFF" />
              </TouchableOpacity>
              <Text style={styles.textHeader1}>Informe o seu novo e-mail</Text>
              <View
                style={{
                  width: "90%",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Icon
                  name="envelope"
                  size={30}
                  // style={{ marginRight:  }}
                  color="#fff"
                />
                <TextInput
                  style={[
                    styles.input,
                    {
                      flex: 1,
                      textAlign: "left",
                      paddingStart: 10,
                      fontSize: 25,
                    },
                  ]}
                  placeholder={`seuemail@seuprovador.com`}
                  placeholderTextColor="#ccc"
                  multiline={false}
                  autoCapitalize="none"
                  autoFocus={true}
                  value={this.state.email}
                  onChangeText={this.handlerInput}
                />
              </View>
              <ButtonConfirm
                text="Continuar"
                disabled={this.state.confirmDisabled}
                onPress={this.handlerSubmit}
                msgDisabled="Por favor, preencha um email válido."
              />
            </ScrollView>
          </ImageBackground>
        </KeyboardAvoidingView>
      </>
    );
  }
}

export default EditarEmail;
